var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackYourProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Track_your_progress",
    "data-name": "Track your progress",
    transform: "translate(2168 5573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3829",
    "data-name": "Group 3829",
    transform: "translate(-2326 -5682)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M29.5,0A29.5,29.5,0,1,1,0,29.5,29.5,29.5,0,0,1,29.5,0Z",
    transform: "translate(158 109)",
    fill: "#ffdcbd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3830",
    "data-name": "Group 3830",
    transform: "translate(34.001 1612.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M41.492,13.44a5.012,5.012,0,0,0-3.811-1.669h-5.45a8.591,8.591,0,0,0-15.505,0H11.277a4.968,4.968,0,0,0-5.016,5.651L8.657,37.5a6.227,6.227,0,0,0,6.025,5.349h19.59A6.227,6.227,0,0,0,40.3,37.5l2.4-20.075A5.009,5.009,0,0,0,41.492,13.44ZM24.479,9.421a6.069,6.069,0,1,1-6.069,6.07A6.077,6.077,0,0,1,24.479,9.421Zm15.694,7.7-2.4,20.074a3.669,3.669,0,0,1-3.5,3.111H14.682a3.673,3.673,0,0,1-3.5-3.109L8.786,17.119a2.43,2.43,0,0,1,2.492-2.807H15.96a8.61,8.61,0,1,0,17.037,0h4.684a2.43,2.43,0,0,1,2.492,2.807Z",
    transform: "translate(-2197.223 -7180.773)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M43.779,23.1a1.27,1.27,0,0,0,1.795-1.8l-3.542-3.542a1.271,1.271,0,0,0-1.8,1.8Z",
    transform: "translate(-2216.833 -7186.9)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackYourProgress);
export default __webpack_public_path__ + "static/media/trackYourProgress.db29d9e11fe41a22f402926c5b62c06b.svg";
export { ForwardRef as ReactComponent };